<style>
    span {
        color: #0074d9;
    }
    span:hover {
        cursor: pointer;
    }
    .search-result--grey-background {
        background-color: rgba(0, 0, 0, 0.05);
        background-image: none;
    }
    #search-result__edit-text-area {
        position: relative;
    }
    #search-result__edit-button {
        display: none;
        position: absolute;
        right: 0;
    }
    .search-result--center-text {
        text-align: center;
    }
    @media (hover: hover) {
        #search-result:hover #search-result__edit-button {
            display: block;
        }
    }

    canvas {
        border: 1px solid black;
        touch-action: none;
    }

    /* we show it when editing on mobile only. */
    #mobile-editor {
        display: none;
    }

    @media only screen and (max-width: 600px) {
        #search-result__edit-button {
            display: block;
            margin: .6em auto 0;
            position: static;
        }
        #mobile-editor {
            position: fixed;
            z-index: 2;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: white;
        }
        #mobile-editor img {
            position: fixed;
            top: 0;
            z-index: 5;
        }
        #mobile-editor__bottom-background {
            position: fixed;
            z-index: 6;
            bottom: 0;
            background-color: rgba(0,0,0,.75);
            width: 100%;
            height: 60px;
        }
        #mobile-editor__close {
            position: fixed;
            z-index: 6;
            right: 10px;
            padding: 0 .4em;
            background: rgba(0,0,0,.5);
        }
        #mobile-editor__share {
            position: fixed;
            z-index: 6;
            right: 17px;
            bottom: 7px;
        }
        #mobile-editor__download {
            position: fixed;
          z-index: 6;
          bottom: 11px;
          right: 17px;
          font-size: .8em;
        }
        #mobile-editor__download--chrome {
          font-size: .8em;
        }
        #mobile-editor__text-position {
            position: fixed;
            z-index: 6;
            bottom: 2px;
            left: 5px;
        }
        #mobile-editor__instructions {
          position: fixed;
          z-index: 4;
          bottom: 50px;
        }
    }
</style>

<script>
    
import { moveCanvasToImageElement, drawMeme, shareMeme, loadImage } from './memeTools.js'
import { isMobile, canShare } from './constants'
import { recentMemes } from './storage'
import { onMount } from 'svelte'
import 'hammerjs'

export let result
export let timings
export let elementNumber

// various elements
const baseImageElement = document.createElement('canvas')
const canvasElement = document.createElement('canvas')
const textCheck = document.createElement('canvas')

let imageElement
let mobileImageElement
let downloadLink
let mobileDownloadLink
const textAreaElement = []
let mobileMemeEditor

// static resources
const originalStrippedText = result.doc.content.replace(/(<([^>]+)>)/gi, '')
const baseImageUrl = `/static/data/thumbs/season-${result.ref.slice(1, 3)}/episode-${result.ref.slice(4, 6)}/${result.ref}.bpg`

// editing shenanigans
let editingMeme = false
let activeTextArea = 0
let pinchTimeStamp = 0
let textAreas = [
  {
    memeText: originalStrippedText,
    fontSize: 40,
    textPosition: 'bottom'
  }
]

// MEME EDITING FUNCTIONS
function addTextArea (position = '') {
  textAreas = [
    ...textAreas,
    { memeText: '', fontSize: 40, textPosition: position }
  ]
}

// I need to use this for the on:focus to work in the textarea properly
function autofocus (e) {
  e.focus()
}

function enableEditing () {
  editingMeme = true
  if (isMobile) {
    mobileMemeEditor.style.display =
                    'block'
  }
  updateMeme()
}

function disableEditing () {
  editingMeme = false
  if (isMobile) {
    mobileMemeEditor.style.display = 'none'
  }
  if (textAreas[0].memeText === '') {
    textAreas[0].memeText = originalStrippedText
  }
}

function updateMeme () {
  textAreas.forEach((textArea, index) => {
    if (textArea.textPosition === 'subtitle') {
      textArea.memeText = originalStrippedText
      textAreas = textAreas // force the ui to lock the fontsize/textarea
    }
  })
  drawMeme(canvasElement, textAreas, baseImageElement, textCheck)
  moveCanvasToImageElement(canvasElement, imageElement)

  if (isMobile) {
    moveCanvasToImageElement(canvasElement, mobileImageElement)
  }

  // I'm not sure why this doesn't bind
  // I think hrefs can't be auto-updated in svelte... :(
  downloadLink.href = imageElement.src
  mobileDownloadLink.href = imageElement.src
}

// MOBILE SPECIFIC FUNCTIONS
function getActiveAreaFromClick (clickX, clickY) {
  const ctx = textCheck.getContext('2d')
  const scale = canvasElement.width / window.innerWidth
  const colorInfo = ctx.getImageData(clickX * scale, clickY * scale, 1, 1)
    .data
  const activeArea = colorInfo[0] / 25 - 1
  return activeArea
}

function handleClick (e) {
  console.log(e)
  const activeArea = getActiveAreaFromClick(e.clientX, e.clientY)

  // we found color! Time to make an area active.
  if (activeArea >= 0) {
    console.log(activeArea)
    activeTextArea = activeArea
    textAreaElement[activeArea].focus()
  } else {
    if (e.clientY < mobileImageElement.height / 2) {
      addTextArea('top')
    } else {
      addTextArea('bottom')
    }
  }
}

function editorShareMeme () {
  addToRecentMemes()
  shareMeme(canvasElement)
}

function addToRecentMemes () {
  recentMemes.update(currentMemes => {
    const updatedCurrentMemes = [
      {
        index: result.ref,
        textAreas: JSON.parse(JSON.stringify(textAreas))
      },
      ...currentMemes
    ]
    if (updatedCurrentMemes.length > 12) {
      updatedCurrentMemes.length = 12
    }
    return updatedCurrentMemes
  })
}

// ONLOAD
onMount(() => {
  const hammertime = new Hammer(mobileImageElement)
  hammertime.on('pinch', (e) => {
    console.log(e)
    const activeArea = getActiveAreaFromClick(e.center.x, e.center.y)

    // 33ms = 30fps
    if (e.timeStamp - pinchTimeStamp >= 50) {
      pinchTimeStamp = e.timeStamp

      if (activeArea >= 0) {
        activeTextArea = activeArea
        console.log(activeArea)
        if (e.additionalEvent === 'pinchout') {
          console.log('out')
          if (textAreas[activeArea].fontSize < 72) {
            textAreas[activeArea].fontSize =
                                    textAreas[activeArea].fontSize + 2
          }
        } else if (e.additionalEvent === 'pinchin') {
          console.log('in')
          if (textAreas[activeArea].fontSize > 22) {
            textAreas[activeArea].fontSize =
                                    textAreas[activeArea].fontSize - 2
          }
        }
        updateMeme()
      }
    }
  })
  hammertime.get('pinch').set({ enable: true })
  hammertime.get('rotate').set({ enable: false })
  hammertime.get('tap').set({ enable: false })
  hammertime.get('doubletap').set({ enable: false })
  hammertime.get('pan').set({ enable: false })
  hammertime.get('swipe').set({ enable: false })
  hammertime.get('press').set({ enable: false })
})

loadImage(baseImageElement, baseImageUrl, () => {
  moveCanvasToImageElement(baseImageElement, imageElement)
})
</script>

<div id="mobile-editor" bind:this="{mobileMemeEditor}">
    <img
        bind:this="{mobileImageElement}"
        width="100%"
        alt="{originalStrippedText}"
        on:click="{handleClick}"
    />
    {#if editingMeme && isMobile}
    <button id="mobile-editor__close" on:click="{disableEditing}">
        ×
    </button>
    <div id="mobile-editor__instructions">
        <ul>
            <li>Tap to add/edit text</li>
            <li>Pinch to resize</li>
            <li>Long Press actions sometimes works...</li>
            <li>Download usually works {#if canShare}<a class="button" id="mobile-editor__download--chrome" bind:this="{mobileDownloadLink}" href="{imageElement.src}" download="{result.ref}_{textAreas[0].memeText}.jpg">download</a>{/if}</li>
        </ul>
    </div>
    <div id="mobile-editor__bottom-background"></div>
    <div id="mobile-editor__text-position">
        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'top'} on:change={updateMeme}>
            <span class="checkable">Top</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'bottom'} on:change={updateMeme}>
            <span class="checkable">Bottom</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'subtitle'} on:change={updateMeme}>
            <span class="checkable">Subtitle</span>
        </label>

        <br />

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'above'} on:change={updateMeme}>
            <span class="checkable">Above</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'below'} on:change={updateMeme}>
            <span class="checkable">Below</span>
        </label>
    </div>
    {#if canShare}
    <button id="mobile-editor__share" on:click="{editorShareMeme}">share</button>
    {:else}
    <a class="button" id="mobile-editor__download" bind:this="{mobileDownloadLink}" href="{imageElement.src}" download="{result.ref}_{textAreas[0].memeText}.jpg" on:click="{addToRecentMemes}">download</a>
    {/if}
    {/if}
</div>

<div class="flex one two-600 three-1000 grow vert-align-center" class:search-result--grey-background="{elementNumber % 2 === 0}" id="search-result">
    <div class="search-result--center-text">
        <img
            bind:this="{imageElement}"
            width="320"
            alt="{originalStrippedText}"
        />
        {#if editingMeme}
        <br />
        <a
            class="button"
            bind:this="{downloadLink}"
            href="{imageElement.src}"
            download="{result.ref}_{textAreas[0].memeText}.jpg"
            on:click="{addToRecentMemes}"
            >Download</a
        >
        <button class="error" on:click="{disableEditing}">Stop Editing</button>
        {/if}
    </div>
    <div id="search-result__edit-text-area" class="search-result--center-text">
        {#if editingMeme} {#each textAreas as area, i (i)}
        <textarea
            bind:this="{textAreaElement[i]}"
            rows="2"
            cols="1"
            on:focus="{()=>{activeTextArea=i}}"
            bind:value="{area.memeText}"
            on:input="{updateMeme}"
            use:autofocus
        ></textarea>
        {/each}
        <button on:click="{addTextArea}" style="float: right;">+</button>
        {:else}
        <span
            title="Click to Meme"
            role="button"
            on:click|preventDefault="{enableEditing}"
            >{@html result.doc.content}</span
        >
        <button id="search-result__edit-button" on:click="{enableEditing}">Edit</button>
        {/if}
    </div>
    <div class="search-result-details">
        {#if editingMeme && !isMobile}
        <h3>Text Location</h3>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'above'} on:change={updateMeme}>
            <span class="checkable">Above</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'top'} on:change={updateMeme}>
            <span class="checkable">Top</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'bottom'} on:change={updateMeme}>
            <span class="checkable">Bottom</span>
        </label>

        <label
            data-tooltip="Subtitle text/fontsize cannot be changed"
            class="tooltip-left"
        >
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'subtitle'} on:change={updateMeme}>
            <span class="checkable">Subtitle</span>
        </label>

        <label>
            <input type=radio bind:group={textAreas[activeTextArea].textPosition}
            value={'below'} on:change={updateMeme}>
            <span class="checkable">Below</span>
        </label>

        <h3>Font Size ({textAreas[activeTextArea].fontSize}px)</h3>
        <input
            type="range"
            min="22"
            max="72"
            step="2"
            bind:value="{textAreas[activeTextArea].fontSize}"
            on:input="{updateMeme}"
        />

        <!-- <button on:click="{addToMemeCart}">Add To MemeCart</button> -->
        {:else}
        <ul>
            <li>Episode: {result.ref.split("_")[0]}</li>
            <li>Line Number: {result.ref.split("_")[1]}</li>
            <li>
                Timing: {timings[result.ref].start} - {timings[result.ref].end}
            </li>
        </ul>
        {/if}
    </div>
</div>
